/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Owner_Locked_HelpInputs */



/**
* | output |
* | --- |
* | "The team owner is always an Admin." |
*
* @param {Team_Manager_Owner_Locked_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_owner_locked_help = /** @type {((inputs?: Team_Manager_Owner_Locked_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Owner_Locked_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le propriétaire de l'équipe est toujours Admin.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Teaminhaber ist immer Admin.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il proprietario del team è sempre Admin.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Владелец команды всегда администратор.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El propietario del equipo siempre es Admin.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队所有者始终是管理员。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームのオーナーは常に管理者です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम का मालिक हमेशा एडमिन होता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O proprietário da equipa é sempre Admin.")
	return /** @type {LocalizedString} */ ("The team owner is always an Admin.")
});